export const formatWalletBalance = (
  balance: number | undefined | string,
  decimals = 2,
) => {
  if (balance === undefined || balance === null) {
    return undefined;
  }

  if (typeof balance === 'string') return balance;

  const localeNumber = balance.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  return `$${localeNumber}`;
};
